import React from "react";
import { Stack } from "@fluentui/react//lib/Stack";
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  Selection,
} from "@fluentui/react//lib/DetailsList";

import { listS } from "../../../../features/orders/styles/OrdersList.styles";
import { pickUpPointsColumns } from "../columns/receptionPlacesColumns";
import { OrdersColumns } from "../columns/ordersColumn";

export interface OrdersListProps {
  selection: Selection;
  items: Array<any>;
  handleInvoke: any;
}

const OrdersList: React.FC<OrdersListProps> = ({
  items,
  selection,
  handleInvoke,
}) => {
  return (
    <Stack>
      <DetailsList
        items={items}
        columns={OrdersColumns}
        styles={listS}
        setKey="items"
        selection={selection}
        layoutMode={DetailsListLayoutMode.justified}
        selectionPreservedOnEmptyClick={true}
        selectionMode={SelectionMode.single}
        onItemInvoked={handleInvoke}
        usePageCache={true}
      />
    </Stack>
  );
};

export default OrdersList;
